import React from "react"
import styled, { css } from "styled-components"
import PropTypes from "prop-types"

const FilterResultsCount = styled.div`
  display: flex;
  justify-content: ${props => (props.$isPanel ? "left" : "center")};
  font-family: system-ui;

  ${props =>
    props.$variant === "routes" &&
    css`
      color: #1f1f23;
      justify-content: right;

      @media only screen and (${props.theme.screen.medium.max}) {
        justify-content: left;
      }
    `}

  .results-display-count {
    font-size: 12px;
    line-height: 24px;
    & > b {
      font-size: 16px;
    }
  }

  @media only screen and (${props =>
      props.$isPanel
        ? props.theme.screen.medium.max && props.$variant !== "routes"
        : props.theme.screen.large.min}) {
    .results-display-count {
      display: none;
    }
  }
`

const DisplayFilterResultCount = ({
  resultCount,
  countOffset,
  totalResults,
  isPanel,
  variant,
}) => {
  let showingResults = resultCount + countOffset

  return (
    <>
      {variant === "routes" ? (
        <FilterResultsCount $isPanel={isPanel} $variant={variant}>
          <p className="results-display-count">
            Displaying{" "}
            {totalResults > showingResults ? showingResults : totalResults} of{" "}
            {totalResults} routes
          </p>
        </FilterResultsCount>
      ) : (
        <FilterResultsCount $isPanel={isPanel} $variant={variant}>
          <p className="results-display-count">
            Displaying <b>{resultCount + countOffset}</b> of{" "}
            <b>{totalResults} tours</b>
          </p>
        </FilterResultsCount>
      )}
    </>
  )
}

DisplayFilterResultCount.propTypes = {
  resultCount: PropTypes.number,
  countOffset: PropTypes.number,
  totalResults: PropTypes.number,
  isPanel: PropTypes.bool,
  variant: PropTypes.string,
}

export default DisplayFilterResultCount
